var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Layout"},[_c('Header'),_c('Map',{attrs:{"facList":_vm.facList,"anjuanList":_vm.anjuanList,"zaixianList":_vm.zaixianList}}),_c('Footer'),_c('videoList',{ref:"videolist"}),_c('el-button',{staticClass:"JumpUrlBtn",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("物联监测桥道总览")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }